import { Check, AlertTriangle } from "lucide-react";
import { CompareTable } from "../components/Pill";
import { COMPARE_COLUMNS, FULL_COMPARE, OVERALL_RATING, METHOD_SUMMARIES } from "../mock";
import { useContent } from "../context/ContentContext";

export default function Compare() {
  const { c } = useContent();
  const cp = c.compare;
  return (
    <main>
      <section className="bg-[var(--navy)] py-16 lg:py-20">
        <div className="mx-auto max-w-[1200px] px-5 lg:px-8">
          <p className="text-[12px] font-bold uppercase tracking-[0.14em] text-[#5aa0e0]">{cp.heroEyebrow}</p>
          <h1 className="font-display mt-3 text-[38px] font-extrabold leading-tight tracking-tight text-white sm:text-[48px]">{cp.heroTitle}</h1>
          <p className="mt-4 max-w-2xl text-[17px] leading-relaxed text-slate-300">{cp.heroSubtitle}</p>
        </div>
      </section>

      <section className="bg-white py-16 lg:py-20">
        <div className="mx-auto max-w-[1200px] px-5 lg:px-8">
          <p className="mb-6 max-w-4xl rounded-xl bg-slate-50 p-4 text-[13px] leading-relaxed text-slate-500">{cp.disclaimer}</p>
          <CompareTable columns={COMPARE_COLUMNS} rows={FULL_COMPARE} overall={OVERALL_RATING} />
        </div>
      </section>

      <section className="bg-[#f7f8fa] py-16 lg:py-20">
        <div className="mx-auto max-w-[1200px] px-5 lg:px-8">
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
            {METHOD_SUMMARIES.map((m, i) => (
              <div key={i} className="rounded-2xl border border-slate-200 bg-white p-7">
                <h3 className="font-display text-[22px] font-bold text-[var(--ink)]">{m.title}</h3>
                <p className="mt-3 text-[15px] leading-relaxed text-slate-500">{m.body}</p>
                <div className="mt-6 grid grid-cols-1 gap-6 sm:grid-cols-2">
                  <div>
                    <p className="text-[12px] font-bold uppercase tracking-wide text-emerald-600">Strengths</p>
                    <ul className="mt-3 space-y-2">
                      {m.strengths.map((s, j) => (
                        <li key={j} className="flex items-start gap-2 text-[14px] text-[var(--ink)]">
                          <Check size={15} className="mt-0.5 shrink-0 text-emerald-500" strokeWidth={3} /> {s}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div>
                    <p className="text-[12px] font-bold uppercase tracking-wide text-amber-600">Considerations</p>
                    <ul className="mt-3 space-y-2">
                      {m.considerations.map((s, j) => (
                        <li key={j} className="flex items-start gap-2 text-[14px] text-slate-600">
                          <AlertTriangle size={15} className="mt-0.5 shrink-0 text-amber-500" /> {s}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
